import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { customEvents_template } from "../components/templates/customEvents_template";

declare var ko: any;
declare var page: any;

export class customEvents extends sentinelModule {

    protected XHRHdl: XMLHttpRequestHandler;
    protected customEvents_template: customEvents_template;

    protected getModuleName(): string {
        return "customEvents";
    }

    public buildContent(): Array<Element> {

        const parentContent = super.buildContent();

        this.customEvents_template = new customEvents_template('customEvents', this.viewModel, this);

        return [...parentContent, this.customEvents_template.build()];
    }

    fillPage() : void {

        this.getPermissions();
    }

    public filterSimpleCancel(){}

    public filterSimpleOnChange() {
        this.getFormData();
    }

    protected onSubmitEdit(){

        this.loadingIn(this.customEvents_template.builtTemplate.querySelector("#customEvents-results"));

        let subViewModel = this.customEvents_template.getViewModelForRequest();

        let customEventsReq_url: string = '/api/settings/customEvents/update/';
        let customEventsReq_params: Array<Array<string>> = [];
        customEventsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customEventsReq_url, customEventsReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdateEventsReturn;
        this.XHRHdl.execute();
    }

    protected onSubmitCreate(){

        this.loadingIn(this.customEvents_template.builtTemplate.querySelector("#customEvents-results"));

        let subViewModel = this.customEvents_template.getViewModelForRequest();

        let customEventsReq_url: string = '/api/settings/customEvents/create/';
        let customEventsReq_params: Array<Array<string>> = [];
        customEventsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customEventsReq_url, customEventsReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdateEventsReturn;
        this.XHRHdl.execute();
    }

    protected onSubmitDelete(){

        this.loadingIn(this.customEvents_template.builtTemplate.querySelector("#customEvents-results"));

        let subViewModel = this.customEvents_template.getViewModelForRequest();

        let customEventsReq_url: string = '/api/settings/customEvents/delete/';
        let customEventsReq_params: Array<Array<string>> = [];
        customEventsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customEventsReq_url, customEventsReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdateEventsReturn;
        this.XHRHdl.execute();
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData() {

        this.loadingIn(this.customEvents_template.builtTemplate.querySelector("#customEvents-results"));

        let subViewModel = this.customEvents_template.getViewModelForRequest();

        let customEventsReq_url: string = '/api/settings/customEvents/getAll/';
        let customEventsReq_params: Array<Array<string>> = [];
        customEventsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customEventsReq_url, customEventsReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    
    protected onGetFormDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let vnApp = obj.getVnAppZone().app;
                let loggedUserId = vnApp.loggedUser.user.id;

                obj.customEvents_template.setCustomEvents(responseParsed);
                obj.loadingOut(obj.customEvents_template.builtTemplate);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.customEvents_template.builtTemplate.querySelector("#customEvents-results"));
                }
            }
        }
    }

    protected getPermissions(){

        this.loadingIn(this.customEvents_template.builtTemplate.querySelector("#customEvents-results"));

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.customEvents_template.builtTemplate);
                obj.customEvents_template.setSideMenuPermissionsData(responseParsed);
            })

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    obj.getFormData();

                    // LOADING : ends
                    obj.loadingOut(obj.customEvents_template.builtTemplate.querySelector("#customEvents-results"));
                }
            }
        }
    }

    protected onUpdateEventsReturn(req, obj){
        
        return function () {

            obj.manageResponse(req, obj, function () {

                obj.customEvents_template.clearErrors();

                let responseParsed = JSON.parse(req.request.response);

                let vnApp = obj.getVnAppZone().app;
                let loggedUserId = vnApp.loggedUser.user.id;

                // custom error handling
                if (responseParsed.nameError) {

                    obj.customEvents_template.getTemplateViewModel().nameError(responseParsed.nameError)
                } else if (responseParsed.categoryError) {

                    obj.customEvents_template.getTemplateViewModel().categoryError(responseParsed.categoryError);
                } else if (responseParsed.descriptionError) {
                
                    obj.customEvents_template.getTemplateViewModel().descriptionError(responseParsed.descriptionError)
                } else if (responseParsed.generalError) {
                
                    obj.customEvents_template.getTemplateViewModel().generalError(responseParsed.generalError)
                } else {
                    
                    // success
                    obj.customEvents_template.setCustomEvents(responseParsed);
                    obj.customEvents_template.onCloseCreate();
                    obj.customEvents_template.onCloseEdit();

                    let notifMessage = '';
    
                    if (req.url.includes('/create/')) {
    
                        notifMessage = "Event has been added successfully.";                    
                    } else if (req.url.includes('/update/')) {
    
                        notifMessage = "Event has been updated successfully.";                    
                    } else if (req.url.includes('/delete/')){

                        notifMessage = "Event has been deleted successfully. "
                    }

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, notifMessage);
                    obj.getVnAppZone().showNotificationToModule();
                    obj.loadingOut(obj.customEvents_template.builtTemplate.querySelector("#customEvents-results"));
                }
            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.customEvents_template.builtTemplate.querySelector("#customEvents-results"));
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/customEvents.ts